import Axios from 'axios'
import {calendarUrls} from '../urls'

export default {
  get_calendar (context, data) {
    Axios.post(calendarUrls.getCalendar, data).then(function (response) {
      context.commit('GET_CALENDAR', response.data)
    })
  },
  get_calendar_inventory (context, data) {
    Axios.post(calendarUrls.getCalendarInventory, data).then(function (response) {
      context.commit('GET_CALENDAR', response.data)
    })
  },
  get_calendar_facility (context, data) {
    Axios.post(calendarUrls.getCalendarFacility, data).then(function (response) {
      context.commit('GET_CALENDAR', response.data)
    })
  },
  get_calendar_external_facility (context, data) {
    Axios.post(calendarUrls.getCalendarExernalFacility, data).then(function (response) {
      context.commit('GET_CALENDAR', response.data)
    })
  },
  get_camping_sites_facility (context, data) {
    Axios.post(calendarUrls.getCalendarCampSitesFacility, data).then(function (response) {
      context.commit('GET_CALENDAR', response.data)
    })
  },


  get_partner_calendar (context, data) {
    Axios.post(calendarUrls.getPartnerCalendar, data).then(function (response) {
      context.commit('GET_CALENDAR', response.data)
    })
  },
  get_calendar_facility_bookings (context, data) {
    Axios.post(calendarUrls.getFacilityBookings, data).then(function (response) {
      context.commit('GET_ALL_BOOKINGS', response.data)
    }).catch(function () {
      context.commit('GET_ALL_BOOKINGS', { data: [] })
      // console.log(error.data)
    })
  },
  get_calendar_inventory_bookings (context, data) {
    Axios.post(calendarUrls.getInventoryBookings, data).then(function (response) {
      context.commit('GET_ALL_BOOKINGS', response.data)
    }).catch(function () {
      context.commit('GET_ALL_BOOKINGS', { data: [] })
      // console.log(error.data)
    })
  },
  get_calendar_inventory_partner_bookings (context, data) {
    Axios.post(calendarUrls.getInventoryPartnerBookings, data).then(function (response) {
      context.commit('GET_ALL_BOOKINGS', response.data)
    }).catch(function () {
      context.commit('GET_ALL_BOOKINGS', { data: [] })
      // console.log(error.data)
    })
  },
  get_conservation_vehicle_calendar (context, dates) {
    
    Axios.post(calendarUrls.getConservationVehicles, dates).then(function (response) {
      context.commit('GET_ALL_RECORDS', response.data)
    })
  },
  get_partner_conservation_vehicle_calendar (context, dates) {
    Axios.post(calendarUrls.getPartnerConservationVehicles, dates).then(function (response) {
      context.commit('GET_ALL_RECORDS', response.data)
    })
  },
  get_conservation_bookings (context, data) {
    Axios.post(calendarUrls.getConservationBookings, data).then((response) => {
      context.commit('GET_ALL_BOOKINGS', response.data)
    })
  },
  get_conservation_partner_bookings (context, data) {
    Axios.post(calendarUrls.getConservationPartnerBookings, data).then((response) => {
      context.commit('GET_ALL_BOOKINGS', response.data)
    })
  },
  get_vehicle_bookings (context, data) {
    Axios.post(calendarUrls.getVehicleBookings, data).then((response) => {
      context.commit('GET_ALL_BOOKINGS', response.data)
    })
  },
  get_vehicle_partner_bookings (context, data) {
    Axios.post(calendarUrls.getVehiclePartnerBookings, data).then((response) => {
      context.commit('GET_ALL_BOOKINGS', response.data)
    })
  }
}
